export default "__VITE_ASSET__a4eRfOCN__"